document.addEventListener('DOMContentLoaded', () => {
  const submitBtn: HTMLButtonElement | null =
    document.querySelector('.KycChooseSubmit')
  const radioButtons: NodeListOf<HTMLInputElement> =
    document.querySelectorAll('.KycChooseRadio')

  if (!submitBtn || !radioButtons.length) return

  const handleDisabledSubmitButton = () => {
    const hasSelectedRadio: boolean = !!document.querySelector(
      '.KycChooseRadio:checked'
    )

    if (hasSelectedRadio) {
      submitBtn.removeAttribute('disabled')
    } else {
      submitBtn.setAttribute('disabled', 'true')
    }
  }

  handleDisabledSubmitButton()

  radioButtons.forEach(radio => {
    radio.addEventListener('change', () => {
      handleDisabledSubmitButton()
    })
  })
})
